module.exports = __webpack_public_path__ + "img/icon_smart_enviroment.adfe9adf.png";